/**
 * Magic-string lockbox for the Notification Center port (PROD-867 epic;
 * PR 1 = PROD-868).
 *
 * Every literal here is copied verbatim from Flutter — see
 * `docs/CONVERSIONS/notification-center-port/CONVERSION_NOTES.md`.
 */

// ─── HTTP endpoints ──────────────────────────────────────────────────────────
// Flutter `notification_center_data_source_impl.dart:23-72` +
// `api_constants.dart:410-417`.

export const NOTIFICATIONS_BASE = '/api/Notifications';

export const URL_USER_NOTIFICATIONS = `${NOTIFICATIONS_BASE}/UserNotifications`;
export const URL_MARK_NOTIFICATION_AS_READ = `${NOTIFICATIONS_BASE}/MarkNotificationAsRead`;
export const URL_GET_UNSEEN_COUNT = `${NOTIFICATIONS_BASE}/GetUserUnSeenNotificationCount`;
export const URL_RESET_SEEN_COUNT = `${NOTIFICATIONS_BASE}/ResetNotificationSeenCount`;

// ─── SignalR ─────────────────────────────────────────────────────────────────
// Flutter `api_constants.dart:546-548` + `menu_widget.dart:83-95`.

export const NOTIFICATIONS_SIGNALR_HUB = '/api/notifications/NotificationsHub';
export const NOTIFICATIONS_SIGNALR_METHOD = 'NotificationCountChanged';

// ─── Subject enum (display string ↔ enum) ────────────────────────────────────
// Flutter `notification_model.dart:62-74`. The wire value IS the display
// string (with spaces); the enum constant name is the React-side name.

export const SUBJECT_DISPLAY = {
  APPOINTMENT_BOOKED: 'Appointment Booked',
  APPOINTMENT_CANCELED: 'Appointment Canceled',
  APPOINTMENT_COMPLETE: 'Appointment Complete',
  APPOINTMENT_REMINDER: 'Appointment Reminder',
} as const;

export type SubjectEnum = keyof typeof SUBJECT_DISPLAY;
export type SubjectDisplay = (typeof SUBJECT_DISPLAY)[SubjectEnum];

// ─── Pagination ──────────────────────────────────────────────────────────────
// Flutter `notification_center_screen.dart:44` uses pageSize=1 on the
// initial fetch — that's a perf hack that breaks the bloc's hasMoreItems
// calculation (which compares to `defaultPageSize` at bloc:84). React drops
// the quirk per orchestrator Q-A approval (2026-05-21). See CONVERSION_NOTES §13.

export const DEFAULT_PAGE_SIZE = 20;
